import React from 'react';
import Info from '../Datas/Info';

const Services = () => {
    return (
        <div>
            <Info></Info>
        </div>
    );
};

export default Services;